import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "結案",
    isNumber: true,
  },
];

export const QuestionnaireYearAndMonthClosedCount = {
  label: "每年/每月結案人數(問卷日期)",
  key: "QuestionnaireYearAndMonthClosedCount",
  path: "HealthCenterHealthCheckup/QuestionnaireYearAndMonthClosedCount",
  api: "TCS_V_HCCS02",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.QuestionnaireYearAndMonthClosedCount
      {...options}
    />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "year",
      field: "year",
      header: "年",
      isSum: true,
      isSkip: true,
      transferFun: (data) => {
        let date = data["個案創建日期"];
        if (date) {
          date = new Date(data["個案創建日期"]);
          date = date.getFullYear();
        }
        return date ?? null;
      },
    },
    // {
    //   key: "season",
    //   field: "season",
    //   header: "季",
    //   isSum: true,
    //   isSkip: true,
    // },
    // {
    //   key: "month",
    //   field: "month",
    //   header: "月",
    //   isSkip: true,
    // },
  ],
  filterColumns: [
    { key: "年齡層", type: "string" },
    { key: "性別", type: "string" },
    { key: "教育程度", type: "string" },
    { key: "縣市", type: "string" },
    { key: "鄉鎮", type: "string" },
    { key: "衛生所", type: "string" },
    { key: "個案創建日期", type: "date" },
  ],
  levelColumns,
  columns: [],
};
